import * as React from 'react';
import Button from '@mui/material/Button';
// import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
// import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import Footer from '../../components/footer';
import Header from '../../components/header';
import { InputAdornment, IconButton, Stack } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import MuiPhoneNumber from 'material-ui-phone-number-2';
import { useNavigate } from 'react-router-dom';
// import Link from '@mui/material/Link';
// import { Container } from '@mui/material';
import Download from '../../components/download';
//import { useToasts } from 'react-toast-notifications';
import LeftSection from '../../components/leftsection';
import { useSnackbar } from 'notistack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import appTheme from '../../components/apptheme';
import { useFormik } from 'formik';
import validateSignUpForm from './ValidateSignUpForm';
import validateConfirmSignUpForm from './ValidateConfirmSignUpForm';
import { useDispatch, useSelector } from 'react-redux';
import * as signupActions from '../../actions/signupActions';
import * as loginActions from '../../actions/loginActions';
// import { Formik } from 'formik';
import * as Constants from '../../config/constants';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import Link from '@mui/material/Link';
import * as caseActions from '../../actions/caseActions';

export default function SignUp() {
  const st = useSelector((state) => state.rootReducer);
  //const [activeStep, setActiveStep] = React.useState(0);
  let navigate = useNavigate();
  //const { addToast } = useToasts();
  const { enqueueSnackbar } = useSnackbar();

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const dispatch = useDispatch();
  const [form1SubmitState, setForm1SubmitState] = useState(false);
  const [form2SubmitState, setForm2SubmitState] = useState(false);
  //const [confirmEmail, setConfirmEmail] = useState();
  //const [confirmPassword, setConfirmPassword] = useState();
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (form1SubmitState && !st.isSignUpLoading && st.signuperror === '') {
      console.log('Navigate to Confirm Signup page');
      dispatch(signupActions.setSignupActiveStep(1));
      setForm1SubmitState(false);
    } else if (form2SubmitState && !st.isSignUpLoading && st.confirmsignuperror === '') {
      console.log('Navigate to new page');
      setLoading(false);
      dispatch(loginActions.clearError());
      enqueueSnackbar(Constants.CREATE_ACCOUNT_SUCCESS, {
        variant: 'success'
      });
      dispatch(caseActions.setShowWelcome(true));
      navigate('/sop2web/newcase');
      setForm2SubmitState(false);
    } else if (st.confirmsignuperror !== '') {
      // error on login API call
      setLoading(false);
      setForm2SubmitState(false);
      dispatch(signupActions.setSignupActiveStep(1));
      dispatch(caseActions.setShowWelcome(false));
    }
  }, [
    st.isSignUpLoading,
    st.signuperror,
    st.confirmsignuperror,
    form1SubmitState,
    form2SubmitState
  ]);
  // step 1
  const submitSignup = (values) => {
    var accountRequest = {
      userId: 0,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email.toLowerCase(),
      phone: values.phone.replace(/[- ()]/g, ''),
      password: values.password,
      status: ''
    };
    var backendPhone = values.phone.replace(/[-()]/g, '');
    console.log(accountRequest);
    dispatch(
      signupActions.persistSignup(
        accountRequest.firstName,
        accountRequest.lastName,
        backendPhone,
        accountRequest.email,
        accountRequest.password
      )
    );
    // setConfirmEmail(accountRequest.email);
    // setConfirmPassword(accountRequest.password);
    dispatch(signupActions.requestSignup(accountRequest));
    setForm1SubmitState(true);
  };

  const formikSignup = useFormik({
    initialValues: {
      firstName: st !== undefined ? st.firstName : '',
      lastName: st !== undefined ? st.lastName : '',
      email: st !== undefined ? st.email : '',
      phone: st !== undefined && st.phone !== undefined && st.phone !== '' ? st.phone : '',
      password: st !== undefined ? st.password : '',
      checkTerm: st.checkTerm
    },
    validationSchema: validateSignUpForm,
    onSubmit: (values) => {
      // alert('Submit SignUP API\n' + JSON.stringify(values, null, 2));
      submitSignup(values);
    }
  });

  // step 2
  const formikConfirmSignup = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: st !== undefined ? st.email : '',
      password: st !== undefined ? st.password : '',
      code: '',
      error: ''
    },
    validationSchema: validateConfirmSignUpForm,
    onSubmit: (values) => {
      // alert('Submit SignUP API\n' + JSON.stringify(values, null, 2));
      submitConfirmSignup(values);
    }
  });

  const submitConfirmSignup = (values) => {
    console.log(values);
    //dispatch(signupActions.setSignupActiveStep(0));
    dispatch(
      signupActions.requestConfirmSignUp(
        values.email,
        values.code,
        values.password,
        st.phone,
        st.firstName,
        st.lastName
      )
    );
    setForm2SubmitState(true);
    setLoading(true);
  };

  return (
    <ThemeProvider theme={appTheme}>
      <Header />
      <Grid container component="main" sx={styles.containerStyle}>
        {/* <CssBaseline /> */}
        <Grid item xs={12} sm={12} md={6} sx={styles.photoSectionStyle}>
          <LeftSection />
        </Grid>
        <Grid item xs={12} sm={12} md={6} sx={styles.rightSectionGridStyle}>
          {st.signupActiveStep === 0 ? (
            <Box sx={styles.titleBoxStyle}>
              <Stack spacing={2} sx={styles.titleStackStyle}>
                <Typography variant="h4">Registration</Typography>
                <Typography variant="h6">Let&apos;s get you signed up.</Typography>
              </Stack>
              <Box sx={styles.formCardContainerStyle}>
                <Stack direction="row" sx={styles.formCardTitleStyle}>
                  <Box component="img" alt="Heart Opinion" src={require('../../images/Logo.png')} />
                  <Typography component="h1" variant="h6" color="#003087">
                    HeartOpinion
                  </Typography>
                </Stack>
                <Box
                  component="form"
                  noValidate
                  // onSubmit={formikSignup.handleSubmit}
                  sx={styles.formCardInputStyle}>
                  <TextField
                    size="small"
                    margin="normal"
                    required
                    fullWidth
                    id="firstName"
                    label="First Name"
                    name="firstName"
                    autoComplete="firstName"
                    autoFocus
                    value={formikSignup.values.firstName}
                    onChange={formikSignup.handleChange}
                    error={formikSignup.touched.firstName && Boolean(formikSignup.errors.firstName)}
                    helperText={formikSignup.touched.firstName && formikSignup.errors.firstName}
                  />
                  <TextField
                    size="small"
                    margin="normal"
                    required
                    fullWidth
                    id="lastName"
                    label="Last Name"
                    name="lastName"
                    autoComplete="lastName"
                    value={formikSignup.values.lastName}
                    onChange={formikSignup.handleChange}
                    error={formikSignup.touched.lastName && Boolean(formikSignup.errors.lastName)}
                    helperText={formikSignup.touched.lastName && formikSignup.errors.lastName}
                  />
                  <TextField
                    size="small"
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    value={formikSignup.values.email}
                    onChange={formikSignup.handleChange}
                    error={formikSignup.touched.email && Boolean(formikSignup.errors.email)}
                    helperText={formikSignup.touched.email && formikSignup.errors.email}
                  />
                  <MuiPhoneNumber
                    fullWidth
                    size="small"
                    defaultCountry={'us'}
                    variant="outlined"
                    sx={{ mt: 2 }}
                    value={formikSignup.values.phone}
                    onChange={(value) => formikSignup.setFieldValue('phone', value)}
                    error={formikSignup.touched.phone && Boolean(formikSignup.errors.phone)}
                    helperText={formikSignup.touched.phone && formikSignup.errors.phone}
                  />
                  <TextField
                    size="small"
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    autoComplete="current-password"
                    InputProps={{
                      // <-- This is where the toggle button is added.
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}>
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    value={formikSignup.values.password}
                    onChange={formikSignup.handleChange}
                    error={formikSignup.touched.password && Boolean(formikSignup.errors.password)}
                    helperText={formikSignup.touched.password && formikSignup.errors.password}
                  />
                  <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          size="small"
                          checked={formikSignup.values.checkTerm}
                        />
                      }
                      label="I accept "
                      id="checkTerm"
                      name="checkTerm"
                      sx={{
                        // backgroundColor: '#F2F5F9',
                        // height: 50,
                        mt: 2
                      }}
                      onChange={formikSignup.handleChange}
                    />
                    <Link
                      color="inherit"
                      sx={{ marginTop: 2.8 }}
                      href="https://www.childrenshospital.org/legal/terms-use"
                      target="_blank"
                      rel="noopener noreferrer">
                      Terms and Conditions
                    </Link>
                  </Box>
                  {formikSignup.touched.checkTerm && Boolean(formikSignup.errors.checkTerm) && (
                    <Typography style={styles.errorText}>
                      {formikSignup.errors.checkTerm}
                    </Typography>
                  )}
                  <Box>
                    <Typography style={styles.errorText}>{st.signuperror}</Typography>
                  </Box>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={formikSignup.handleSubmit}
                    sx={styles.formCardButtonStyle}>
                    Sign Up
                  </Button>
                </Box>
              </Box>
              <Box sx={styles.formCardContainerStyle}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', my: 3 }}>
                  <Typography variant="body1">{'Already have an account?'}&nbsp;</Typography>
                  <Button
                    color="inherit"
                    sx={styles.linkTextStyle}
                    onClick={() => {
                      console.info('Navigate to Login in page.');
                      if (st.signuperror !== '' || st.confirmsignuperror !== '')
                        dispatch(loginActions.clearError());
                      navigate('/sop2web/signin');
                    }}>
                    Login here
                  </Button>
                </Box>
              </Box>
              <Box sx={styles.downloadContainerStyle}>
                <Download />
              </Box>
            </Box>
          ) : (
            <Box sx={styles.confirmCardContainerStyle}>
              <CheckCircleIcon color="success" sx={{ fontSize: 100, mt: 4, mb: 2 }} />
              <Typography variant="h6">Confirmation Code Sent!</Typography>
              <Typography variant="subtitle2" sx={{ width: '250px', textAlign: 'center', mt: 1 }}>
                Check your email for your confirmation code.
              </Typography>
              <Box
                component="form"
                // onSubmit={propsForm.handleSubmit}
                sx={styles.formCardInputStyle}>
                <TextField
                  size="small"
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  value={formikConfirmSignup.values.email}
                  onChange={formikConfirmSignup.handleChange}
                  error={
                    formikConfirmSignup.touched.email && Boolean(formikConfirmSignup.errors.email)
                  }
                  helperText={formikConfirmSignup.touched.email && formikConfirmSignup.errors.email}
                />
                <TextField
                  size="small"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  autoComplete="current-password"
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  InputProps={{
                    // <-- This is where the toggle button is added.
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}>
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  value={formikConfirmSignup.values.password}
                  onChange={formikConfirmSignup.handleChange}
                  error={
                    formikConfirmSignup.touched.password &&
                    Boolean(formikConfirmSignup.errors.password)
                  }
                  helperText={
                    formikConfirmSignup.touched.password && formikConfirmSignup.errors.password
                  }
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="code"
                  label="Confirmation Code"
                  name="code"
                  // type="number"
                  // helperText="Confirmation code has been sent to your email. Please check your email for your confirmation code."
                  autoFocus
                  value={formikConfirmSignup.values.code}
                  onChange={formikConfirmSignup.handleChange}
                  error={
                    formikConfirmSignup.touched.code && Boolean(formikConfirmSignup.errors.code)
                  }
                  helperText={formikConfirmSignup.touched.code && formikConfirmSignup.errors.code}
                />

                <Box>
                  <Typography style={styles.errorText}>{st.confirmsignuperror}</Typography>
                </Box>
                <Box sx={{ m: 1, position: 'relative' }}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    onClick={formikConfirmSignup.handleSubmit}
                    color="primary"
                    disabled={loading}
                    sx={{ mt: 1, mb: 2 }}>
                    Confirm
                  </Button>
                  {loading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: green[500],
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px'
                      }}
                    />
                  )}
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mt: 4,
                    mb: 6
                  }}>
                  <Box sx={{ ml: 2 }}>
                    <Button
                      color="inherit"
                      sx={styles.linkTextStyle}
                      onClick={() => {
                        console.info('Resend code.');
                        if (st.confirmsignuperror !== '') dispatch(loginActions.clearError());
                        if (formikConfirmSignup.values.email !== '') {
                          dispatch(
                            signupActions.resendCodeSignUp(formikConfirmSignup.values.email)
                          );
                        } else {
                          dispatch(signupActions.signupFailed('Email can not be empty.'));
                        }
                      }}>
                      <Typography variant="body1" sx={{ color: '#003087' }}>
                        Resend code
                      </Typography>
                    </Button>
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Button
                      onClick={() => {
                        if (st.confirmsignuperror !== '') dispatch(loginActions.clearError());
                        navigate('/sop2web/signin');
                        dispatch(signupActions.setSignupActiveStep(0));
                      }}
                      sx={styles.linkTextStyle}
                      color="inherit">
                      Back to Sign In
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
        </Grid>
        <Footer />
      </Grid>
    </ThemeProvider>
  );
}
const styles = {
  containerStyle: {
    // height: '88vh',
    display: 'flex',
    // alignItems: 'center',
    border: 0,
    justifyContent: 'center',
    backgroundColor: '#EDF3FC'
  },
  photoSectionStyle: {
    backgroundColor: '#EDF3FC',
    display: 'flex',
    alignItems: 'center',
    border: 0
    // justifyContent: 'center'
  },
  rightSectionGridStyle: {
    // height: '86vh',
    backgroundColor: '#EDF3FC',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // justifyContent: 'center',
    minWidth: 500
  },
  titleBoxStyle: {
    alignItems: 'flex-start',
    py: 4
  },
  titleStackStyle: {
    alignItems: 'flex-start'
  },
  formCardContainerStyle: {
    my: 2,
    display: 'flex',
    border: 0,
    boxShadow: 1,
    borderColor: '#747678',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 500,
    background: '#FFFF'
  },
  formCardTitleStyle: {
    mt: 2,
    mx: 2,
    alignItems: 'center',
    justifyContent: 'center'
  },
  formCardInputStyle: {
    mt: 2,
    width: 380
  },
  formCardButtonStyle: {
    mt: 1,
    mb: 2,
    flex: 1
  },
  linkTextStyle: {
    color: '#003087',
    fontSize: 20
  },
  downloadContainerStyle: {
    my: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  confirmCardContainerStyle: {
    display: 'flex',
    border: 0,
    boxShadow: 1,
    borderColor: '#747678',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 500,
    background: '#FFFF'
  },
  errorText: {
    color: '#d32f2f',
    // fontWeight: "normal",
    fontSize: 16,
    //marginBottom: 10,
    marginTop: 0,
    marginLeft: 10,
    textAlign: 'left'
  }
};
